let pending = false;

export function markPasteHarnessApplied(): void {
  pending = true;
}

export function consumePasteHarnessApplied(): boolean {
  if (!pending) return false;
  pending = false;
  return true;
}
